<template>
  <header class="cp-home-header">
    <transition-group name="fade" tag="div" appear>
      <h2 class="cp-header-logo" key='0'>
        <CpLogo/>
      </h2>

      <div class="container" key='1'>
        <div class="cp-header-headline-wrapper">
          <HeaderHeadline/>
        </div>
      </div>

      <MainNavigation key='2' mode="common" />
      <HeaderSubnav key='3' class="mobile-hidden" mode="common" />
    </transition-group>
  </header>
</template>

<script>
import CpLogo from '../atoms/CpLogo';
import HeaderSubnav from './HeaderSubnav';
import HeaderHeadline from '../organisms/HeaderHeadline';
import MainNavigation from './MainNavigation';

export default {
  name: 'TextContentHeader',
  components: {
    CpLogo,
    HeaderSubnav,
    HeaderHeadline,
    MainNavigation
  }
};
</script>

<style lang="scss">
@import '../../scss/atoms/colors';
@import '../../scss/atoms/breakpoints.mixin';
@import '../../scss/templates/home_header';

/* here will be defined content styling */

$top-area-height: 330px;

#toparea {
  position: absolute;
  margin-top: -#{$top-area-height};
  width: 793px;
  left: 50%;
  transform: translateX(-50%);
  color: $color_white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;

  h1 {
    font-size: 46px;
  }
}

.larger-header ~ main #toparea {
  margin-top: -#{$top-area-height + 70};
}

#content > .wrapper {
  display: block !important;
  max-width: 793px;
  margin: 70px auto;
  font-weight: 300;
  line-height: 28px;
  font-size: 17px;

  > ol {
    list-style-type: decimal;
    border-bottom: 1px solid $color-silvergrey;
    padding-left: 24px;
    margin-top: 48px;

    &:nth-of-type(n+10) {
      padding-left: 40px;
    }

    > li {
      display: list-item;
      line-height: 32px;
      font-size: 26px;
      color: $color-blue;
      margin-bottom: 8px;

      > h2 {
        font-size: 26px;
        font-weight: 300;
        line-height: 32px;
        margin: 0;
      }
    }
  }

  h3,
  h3 ~ p {
    display: inline;
  }

  h3 ~ p:after {
    content: ' ';
    display: block;
    margin-bottom: 1.5em;
  }

  h3 {
    font-weight: 400;
    line-height: 28px;
    font-size: 17px;
    margin-right: 0.5em;
  }

  a {
    color: $color-blacky;
    font-weight: 400;
    text-decoration: none;

    &:after {
      display: inline;
      font-family: fontello; // stylelint-disable-line
      content: '\E802';
      font-size: 82%;
      margin: 0 0 0 4px;
      font-weight: 400;
    }

    /* forced to deactivate color style */
    &[style] {
      color: $color-blacky !important;
    }

    &[name]:after {
      content: '';
    }
  }
  /*
  p > strong {
    display: block;
    font-size: 26px;
    line-height: 32px;
    margin: 0;
    border-bottom: 1px solid $color-silvergrey;
    padding-left: 24px;
    margin-top: 48px;

    &:nth-of-type(n+10) {
      padding-left: 40px;
    }
  }
  */
}

.cp-home-header {
  background: transparent url(/assets/img/CP_Header_Arbeitnehmer_01.jpg) no-repeat;
  background-size: cover;
  background-position: bottom right;
  min-height: $top-area-height;
  height: $top-area-height;

  /* it need because of rendering */
  > div {
    display: inline;
  }

  .cp-header-headline-wrapper {
    display: none;
  }

  /deep/ .login-close-button {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

@include bp-max(863px) {
  #toparea {
    width: auto;
    // margin-left: var(--padding-edge);
    // margin-right: var(--padding-edge);
  }

  #content > .wrapper {
    margin-left: var(--padding-edge);
    margin-right: var(--padding-edge);
  }
}

@include bp-max-tablet() {
  #toparea {
    height: 230px !important;
    width: 100%;
    h1 {
      font-size: 36px !important;
      margin-left: 25px;
    }
  }
}
</style>
